import React, { Component } from 'react';
import { NavLink, withRouter } from "react-router-dom";
import Cookies from 'universal-cookie';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Swiper from 'react-id-swiper';
import axios from 'axios';
import Select from "react-select";
import ls from "local-storage";
import Countdown from "../findExplore/Countdown";
import { options } from "../../config/options";
import "../../config/i18n";
import { Trans } from "react-i18next";
import { withTranslation } from "react-i18next";

import Wallet from "./Wallet";
import { CAPTURE_EVENT } from '../../Services/PosthogService';

class SideBar extends Component {
  // static propTypes = {
  //   cookies: instanceOf(Cookies).isRequired
  // };
  constructor(props) {
    super(props);
    //handleItemClick
    this.loggedIn = sessionStorage.getItem('loggedin');
    this.handleItemClick = this.handleItemClick.bind(this);
    this.onChangepack = this.onChangepack.bind(this);
    this.hidecount = this.hidecount.bind(this);
    var walleturl = localStorage.getItem('web_url') + 'app/wallet';
    //const { Cookies } = props;
    this.state = {
      modal: false,
      modal22: false,
      ismsgshown: false,
      isreqshown: false,
      islikeshown: false,
      isvisitorshown: false,
      activeItem: '',
      user_id: '',
      timer_status: 0,
      start_date: '',
      end_date: '',
      disp: '',
      selected_premium: JSON.parse(localStorage.getItem('selected_premium')) || "",
      user_details: '', api_url: localStorage.getItem('api_url'),
      notification_count: '',
      items: [], currency: '', payment: '', license_key: '', premium_price: '', abort: '',
      permium_superlikeCount: 0,
      permium_boostCount: 0,
      lang: ls.get('LangKeySet') || options[0],
      langKey: ls.get('LangValue'),
      currency_code: "",
      float: 'right',
      restrict: false,
      walleturl: walleturl
    };

    this.toggle = this.toggle.bind(this);
    this.toggleclose = this.toggleclose.bind(this);
  }

  changeLang = lang => {

    const { i18n } = this.props;
    const { value } = lang;

    this.setState({
      lang
    });
    console.log("changeLang", lang);
    ls.set('LangKeySet', lang);
    ls.set('LangValue', value);
    i18n.changeLanguage(value);
    //window.location.reload();
    var payment = new FormData();
    payment.set('langValue', value);
    payment.set('user_id', JSON.parse(localStorage.getItem('session_userid')));

    axios({
      method: 'post',
      url: this.state.api_url + 'changeuserlang',
      data: payment,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .then(res => {
        if (res.data.status === "true") {
          window.location.href = '/moulookweb/web'; //relative to domain  
          // window.location.href = '/moulook/web'; //relative to domain  
        }
      })
  };

  componentDidMount() {
    var face_verify_status = JSON.parse(localStorage.getItem('session_faceverificationstatus'));
    this.setState({
      face_verify_status: face_verify_status,
    })

    var datalist = new FormData();
    datalist.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
    datalist.set('language', this.state.langKey);

    axios({
      method: 'post',
      url: this.state.api_url + 'webprofile',
      data: datalist,
      config: {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        }
      }
    }).then(res => {


      if (res.data.status === 'true') {

        console.log(res.data.result);
        const user_details = res.data.result;
        if (user_details.profileimage == "") {
          this.setState({
            restrict: true
          });
          this.props.history.push("/app/Profile/ProfilePhotoEdit")
          console.log("restrict=" + this.state.restrict);
        }
        this.setState({
          wallet_amount: res.data.result.wallet_amount,
          //currency_code:res.data.result.currency_code,
          currency_code: res.data.result.currency,
        });
        document.getElementById('wallet_val').value = this.state.wallet_amount;
        console.log("currency_code=" + this.state.currency_code);

        //   localStorage.setItem('wallet_amount',this.state.wallet_amount); 




      } else {
        cookies.set('onboarded', 'false', { path: "/" });
        cookies.set('signuptab', false);
        this.props.history.push("/login");
      }


    }).catch(error => {
      //alert('falsw');
      this.props.history.push("/login");
    });








    if (this.props.i18n.language) {
      this.setState(
        {
          lang: options.filter(item => item.value === this.props.i18n.language)
        }
      );
    }
    if (this.state.langKey == 'ar') {
      this.setState({
        float: 'left'
      });
    }

    const cookies = new Cookies();

    if (cookies.get('onboarded') === 'true') {
      let data = new FormData();
      data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
      data.append('language', this.state.langKey);
      axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
      axios({
        method: 'post',
        url: this.state.api_url + 'webprofile',
        data: data,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      }).then(res => {
        if (res.data.status === 'true') {
          const user_details = res.data.result;
          localStorage.setItem('cib_status', user_details.cib_status);
          if (user_details.profileimage == "") {
            this.setState({
              restrict: true
            });
          }
          this.setState({
            user_details: user_details,
          });

          if (res.data.result.userstatus === 1) {

            var loginstatus = new FormData();
            loginstatus.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
            loginstatus.set('status', '1');
            loginstatus.set('language', this.state.langKey);

            axios({
              method: 'post',
              url: this.state.api_url + 'webonlinestatus',
              data: loginstatus,
              config: { headers: { 'Content-Type': 'multipart/form-data' } }
            })
            var user = new FormData();
            user.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
            user.set('language', this.state.langKey);
            axios({
              method: 'post',
              url: this.state.api_url + 'webgetcounts',
              data: user,
              config: { headers: { 'Content-Type': 'multipart/form-data' } }
            }).then(res => {
              this.setState({
                notification_count: res.data.result,
              });
              if (this.state.notification_count.message !== '0')
                this.setState({ ismsgshown: true });
              if (this.state.notification_count.visitors !== '0')
                this.setState({ isvisitorshown: true });
              if (this.state.notification_count.superlike_request !== '0')
                this.setState({ isreqshown: true });
              if (this.state.notification_count.like_request !== '0')
                this.setState({ islikeshown: true });
            })

            var premiumlist = new FormData();
            premiumlist.set('platform', 'web');
            premiumlist.set('language', this.state.langKey);
            premiumlist.set('user_id', JSON.parse(localStorage.getItem('session_userid')));

            axios({
              method: 'post',
              url: this.state.api_url + 'premiumlistweb',
              data: premiumlist,
              config: { headers: { 'Content-Type': 'multipart/form-data' } }
            }).then(res => {
              const data = res.data;
              if (data.result[0]) {



                if (res.data.status === 'true')
                  this.setState({
                    items: data.result,
                    activeItem: data.result[0].id,
                    selected_premium: localStorage.getItem('selected_premium') || data.result[0].id,
                    premium_price: data.result[0].original_price,
                    permium_superlikeCount: data.result[0].superlikecount,
                    permium_boostCount: data.result[0].boostcount,
                    currency: data.currency,
                    payment: data.payment,
                    license_key: data.license_key,
                    start_date: data.start_date,
                    end_date: data.end_date,
                    timer_status: data.timer_status
                  });
              }
              console.log("selected_premium");
              console.log(this.state.selected_premium);
              console.log("selected_premium end");

              localStorage.setItem('selected_premium', JSON.stringify(this.state.selected_premium));
              localStorage.setItem('premium_price', JSON.stringify(this.state.premium_price));
              localStorage.setItem('currency_premium_price', JSON.stringify(data.result[0].price));
              localStorage.setItem('currency', JSON.stringify(this.state.currency));
            });
          }
        } else {
          this.props.history.push("/login");
        }
      })
    }

  }

  componentWillMount() {

    const cookies = new Cookies();
    var hosturl = localStorage.getItem('web_url');
    if (cookies.get('onboarded') === 'false') {
      hosturl = hosturl + "login";
      window.location.assign(hosturl);
    }

    let data = new FormData();
    data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
    data.append('language', this.state.langKey);
    axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));

    axios({
      method: 'post',
      url: this.state.api_url + 'webprofile',
      data: data,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    }).then(res => {
      if (res.data.status === 'true') {
        const user_details = res.data.result;
        if (user_details.profileimage == "") {
          this.setState({
            restrict: true
          });
        }
        this.setState({
          user_details: user_details,
        });
      } else {
        cookies.set('onboarded', 'false', { path: "/" });
        cookies.set('signuptab', false);
        this.props.history.push("/login");
      }
    });

  }




  toggle() {
    if (!this.state.modal) {
      let premium_view_properties = {
        properties: {
          user_email: this.state.user_details.email,
          user_age: this.state.user_details.age,
          user_name: this.state.user_details.user_name,
          user_id: this.state.user_details.user_id,
          user_location: this.state.user_details.location
        }
      }

      CAPTURE_EVENT("premium_page_viewed", premium_view_properties)
    }
    this.setState(prevState => ({
      modal: !prevState.modal
    }));

    this.setState({

      start_date: '',
      end_date: '',
      timer_status: 0
    });

    var premiumlist = new FormData();
    premiumlist.set('platform', 'web');
    premiumlist.set('language', this.state.langKey);
    premiumlist.set('user_id', JSON.parse(localStorage.getItem('session_userid')));

    axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));

    axios({
      method: 'post',
      url: this.state.api_url + 'premiumlistweb',
      data: premiumlist,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    }).then(res => {
      const data = res.data;



      if (data.result[0]) {
        this.setState({
          itemss: data.result,
          activeItems: data.result[0].id,
          selected_premium: data.result[0].id,
          premium_price: data.result[0].original_price,
          permium_superlikeCount: data.result[0].superlikecount,
          permium_boostCount: data.result[0].boostcount,
          currency: data.currency,
          payment: data.payment,
          license_key: data.license_key,
          start_date: data.start_date,
          end_date: data.end_date,
          timer_status: data.timer_status
        });
      }
      localStorage.setItem('selected_premium', JSON.stringify(this.state.selected_premium));
      localStorage.setItem('premium_price', JSON.stringify(this.state.premium_price));
      localStorage.setItem('currency_premium_price', JSON.stringify(data.result[0].price));
      localStorage.setItem('currency', JSON.stringify(this.state.currency));
    });
  }
  toggleclose() {
    this.setState({
      modal: false
    });
  }

  handleItemClick(index) {
    this.setState({
      activeItem: index,
      selected_premium: index,
    })
    var premiumlist = new FormData();
    premiumlist.set('premiumid', index);
    premiumlist.set('language', this.state.langKey);
    premiumlist.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
    axios({
      method: 'post',
      url: this.state.api_url + 'premiumid',
      data: premiumlist,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .then(res => {
        const data = res.data;
        this.setState({
          premium_price: data.result.original_price,
          permium_superlikeCount: data.result.superlikecount,
          permium_boostCount: data.result.boostcount,
        });
        localStorage.setItem('selected_premium', JSON.stringify(index));
        localStorage.setItem('premium_price', JSON.stringify(data.result.price));
        localStorage.setItem('currency_premium_price', JSON.stringify(data.result.price));
        // alert(index); 
      });


  }
  onChangepack(e) {
    this.setState({
      selected_premium: e.target.value,
    })

  }

  hidecount(e) {

    this.setState({
      disp: 'none'
    })

  }
  push_to_wallet_page = () => {
    this.props.history.push("/app/wallet");
    window.location.reload();
  }
  render() {
    const { lang } = this.state;
    const { t } = this.props;

    const params = {
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      spaceBetween: 1,
      rebuildOnUpdate: true
    }

    const params2 = {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      slidesPerView: 3,
      slidesPerColumn: 1,
      breakpoints: {
        360: {
          slidesPerView: 3,
        },
        359: {
          slidesPerView: 2,
        }
      }
    };
    let premium, premium_icon;

    if (this.state.user_details.premium_member !== 'true' && this.state.user_details.profileimage !== '') {
      premium = <button className="btn-common" onClick={this.toggle}>{t('Become a Premium Member')}</button>
      premium_icon = '';
    } else if (this.state.user_details.premium_member === 'true') {
      // premium = <button className="btn-common">{t('Premium Member')}</button> 
      premium_icon = <div class="preIcon"></div>
      premium = ""

    }
    // var wallet_amount;

    //    if(typeof this.state.user_details.wallet_amount !== 'null')
    //     {
    //       wallet_amount = this.state.user_details.wallet_amount
    //     }
    //     else
    //     {
    //       wallet_amount = 0;
    //     }

    // if(typeof localStorage.getItem('api_url')!== 'null')
    // {
    //       wallet_amount = localStorage.getItem('wallet_amount');
    // }


    return (
      <div className="sidebarWrap">
        <div className="sideLogoSection text-center">
          {this.state.restrict === true ? <NavLink to="/app/Profile/ProfilePhotoEdit">
            <img src={require('../../assets/img/logo-c-64.png')} className="sideLogo" alt="logo" />
          </NavLink> : <NavLink to="/app/PeopleNear"> <img src={require('../../assets/img/logo-c-64.png')} className="sideLogo" alt="logo" />
          </NavLink>}
        </div>

        <div className="sideProfileBody">
          <div className="media">
            <div className="align-self-center mx-3 relPos">
              <NavLink to="/app/profile">
                <img className="currentUserDP" src={this.state.user_details.images} alt="" />
                {premium_icon}
              </NavLink>

            </div>

            <div className="media-body pFHidden align-self-center">
              {this.state.restrict === true ?
                <NavLink to="/app/Profile/ProfilePhotoEdit">

                  <div class="d-flex align-items-center">
                    <div className="text-truncate text-dark bold-font">{this.state.user_details.user_name}</div>
                    {
                      this.state.face_verify_status && this.state.face_verify_status === true &&
                      <div class="verificationIcon"></div>
                    }

                  </div>
                </NavLink>
                :
                <NavLink to="/app/Profile">
                  <div class="d-flex align-items-center">
                    <div className="text-truncate text-dark bold-font">{this.state.user_details.user_name}</div>
                    {
                      this.state.face_verify_status && this.state.face_verify_status === true &&
                      <div class="verificationIcon"></div>
                    }
                  </div>
                </NavLink>
              }
              {this.state.restrict === true ? <NavLink to="/app/Profile/ProfilePhotoEdit">
                <div className="text-truncate secondaryText esmh-14 regular-font ">{this.state.user_details.location}</div></NavLink>
                : <NavLink to="/app/Profile">
                  <div className="text-truncate secondaryText esmh-14 regular-font ">{this.state.user_details.location}</div></NavLink>}

            </div>

            <div className="align-self-center  ml-3">
              <NavLink to="/app/settings">
                <div className="iconHolder">
                  <div className="backGlow">
                    <div className="settingsIco"></div>
                  </div>
                </div>
              </NavLink>
            </div>
          </div>
        </div>


        <div className="sideListBody">

          <div className="media">
            <div className="align-self-center mr-3">
              <div className="sidebarIcoPos findNewPeopleIco"></div>
            </div>
            <div className="media-body pFHidden align-self-center">
              <NavLink to="/app/PeopleNear" activeClassName="active">
                <div className="text-truncate">
                  <Trans i18nKey="Peoplenearyou"><span className="floating-label">People near you</span> </Trans>
                </div>
              </NavLink>
            </div>
            <div className="align-self-center  ml-3">
            </div>
          </div>

          <div className="media">
            <div className="align-self-center mr-3">
              <div className="nearYouico sidebarIcoPos"></div>
            </div>
            <div className="media-body pFHidden align-self-center">
              <NavLink to="/app/FindNewPeople" activeClassName="active">
                <div className="text-truncate">
                  <Trans i18nKey="Findnewpeople">Find new people</Trans>
                </div>
              </NavLink>
            </div>
            <div className="align-self-center  ml-3">
            </div>
          </div>

          <div className="media" >
            <div className="align-self-center mr-3" >
              <div className="sidebarIcoPos visitorsIco"></div>
            </div>

            <div className="media-body pFHidden align-self-center" onClick={this.hidecount}>
              <NavLink to="/app/Visitors" activeClassName="active">
                <div className="text-truncate">
                  <Trans i18nKey="Visitors">Visitors</Trans></div>
              </NavLink>
            </div>


            {this.state.isvisitorshown && (
              <div className="align-self-center  ml-3" style={{ display: this.state.disp }}>
                <div className={this.state.notification_count.visitors !== '0' ? "visitorsNotifierIco sidebarIcoPos NotifiersizePos" : "none"}>
                  <span>{this.state.notification_count.visitors}</span>
                </div>
              </div>
            )}
          </div>

          {/*  */}
          <div className="media">
            <div className="align-self-center mr-3">
              <div className="sidebarIcoPos creditIco"></div>
            </div>
            <div className="media-body pFHidden align-self-center">



              {/* <NavLink to="/app/wallet" activeClassName="active">
             <div className="text-truncate"><Trans i18nKey="Wallet">Wallet</Trans> <span style={{float:this.state.float}} className="wallet_val" id="wallet_val">{  typeof this.state.user_details.wallet_amount == 'undefined' ? '' : this.state.user_details.wallet_amount +' '+this.state.currency_code }</span></div> 

              </NavLink> */}


              <a href="javascript:;" onClick={this.push_to_wallet_page} activeClassName="active">
                <div className="text-truncate"><Trans i18nKey="Wallet">Wallet</Trans> <span style={{ float: this.state.float }} className="wallet_val" id="wallet_val">{typeof this.state.user_details.wallet_amount == 'undefined' ? '' : this.state.user_details.wallet_amount + ' ' + this.state.currency_code}</span></div>
              </a>

            </div>
          </div>
          <div className="media">
            <div className="align-self-center mr-3">
              <div className="sidebarIcoPos creditIco"></div>
            </div>
            <div className="media-body pFHidden align-self-center">



              <NavLink to="/app/QRcode" activeClassName="active">
                {/* <a href={this.state.walleturl} activeClassName="active">*/}
                {/*  <a href="/app/wallet" activeClassName="active">*/}
                <div className="text-truncate">{t('QR code')} </div>
                {/*   </a>*/}
                {/* /moulook_live/web/ */}
              </NavLink>




            </div>
          </div>


          {/*  */}


          <div className="media">
            <div className="align-self-center mr-3">
              <div className="sidebarIcoPos messageIco"></div>
            </div>
            <div className="media-body pFHidden align-self-center">
              <NavLink to="/app/Message" activeClassName="active">
                <div className="text-truncate">
                  <Trans i18nKey="Message">Message</Trans>
                </div>

              </NavLink>
            </div>
            {this.state.ismsgshown && (
              <div className={this.state.notification_count.message !== '0' ? "align-self-center  ml-3" : "none"}>
                <div className={this.state.notification_count.message !== '0' ? "messageNotifierIco sidebarIcoPos NotifiersizePos" : "none"}>
                  <span>{this.state.notification_count.message}</span>
                </div>

              </div>
            )}

          </div>


          <div className="media">
            <div className="align-self-center mr-3">
              <div className="sidebarIcoPos feedIco"></div>
            </div>
            <div className="media-body pFHidden align-self-center">
              <NavLink to="/app/Feeds" activeClassName="active">
                <div className="text-truncate">{t('Feeds')}</div>
              </NavLink>
            </div>
          </div>

          <div className="media">
            <div className="align-self-center mr-3">
              <div className="sidebarIcoPos tutorialIco"></div>
            </div>
            <div className="media-body pFHidden align-self-center">
              <NavLink to="/app/tutorial" activeClassName="active">
                <div className="text-truncate">
                  <Trans i18nKey="Tutorial">Tutorial</Trans>
                </div>
              </NavLink>
            </div>
          </div>

          <div className="media">
            <div className="align-self-center mr-3">
              <div className="sidebarIcoPos friendsIco"></div>
            </div>
            <div className="media-body pFHidden align-self-center">
              <NavLink to="/app/Friends" activeClassName="active">
                <div className="text-truncate"><Trans i18nKey="Matches">Matches</Trans> </div>
              </NavLink>
            </div>
            <div className="align-self-center  ml-3">
            </div>
          </div>

          <div className="media">
            <div className="align-self-center mr-3">
              <div className="sidebarIcoPos friendReqIco"></div>
            </div>
            <div className="media-body pFHidden align-self-center">
              <NavLink to="/app/FriendRequests" activeClassName="active">
                <div className="text-truncate">
                  <Trans i18nKey="Super likes">Super likes</Trans>
                  {this.state.isreqshown && (
                    <span className={this.state.notification_count.superlike_request !== '0' ? "sidebarIcoPos" : "none"}>
                      ({this.state.notification_count.superlike_request})
                    </span>
                  )}
                </div>
              </NavLink>
            </div>
          </div>


          <div className="media">
            <div className="align-self-center mr-3">
              <div className="sidebarIcoPos likesReqIco"></div>
            </div>
            <div className="media-body pFHidden align-self-center">
              <NavLink to="/app/LikeRequests" activeClassName="active">
                <div className="text-truncate">
                  <Trans i18nKey="Likes">Likes</Trans>
                  {this.state.islikeshown && (
                    <span className={this.state.notification_count.like_request !== '0' ? "sidebarIcoPos" : "none"}>
                      ({this.state.notification_count.like_request})
                    </span>
                  )}
                </div>
              </NavLink>
            </div>

          </div>

          {this.state.user_details.bannerstatus == 1 ?
            <div className="media">
              <div className="align-self-center mr-3">
                <div className="sidebarIcoPos bannerReqIco"></div>
              </div>
              <div className="media-body pFHidden align-self-center">
                <NavLink to="/app/Banner" activeClassName="active">
                  <div className="text-truncate">
                    <Trans i18nKey="Ads Banners">Ads Banners</Trans>
                  </div>
                </NavLink>
              </div>
            </div>
            : ''
          }

          <div className="media">
            <div className="align-self-center mr-3">
              <div className="sidebarIcoPos helpIco"></div>
            </div>
            <div className="media-body pFHidden align-self-center">
              <NavLink exact to={"/app/Help/"} activeClassName="active">
                <div className="text-truncate"><Trans i18nKey="Help">Help</Trans> </div>
              </NavLink>
            </div>
            <div className="align-self-center  ml-3">
            </div>
          </div>
        </div>

        <Select
          defaultValue={lang}
          options={options}
          value={lang}
          onChange={this.changeLang}
          className="App-Select"
        />

        <div className="sidebarLastContent mb-auto">
          {premium}
        </div>


        <Modal isOpen={this.state.modal} toggle={this.toggle} className="premiumPopup vertically-center apd5">
          <ModalHeader toggle={this.toggle}>
            <h4 class="modal-title">
              <Trans i18nKey="Join Premium">Join Premium</Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="premiumPop">
              <div className="premiumImgs">
                <Swiper {...params} shouldSwiperUpdate>
                  {this.state.permium_superlikeCount > 0 ?
                    <div>
                      <div className="premiumImgHolder">
                        <img src={require("../../assets/img/sub_superlike.png")} alt="" className="img-fluid" />
                      </div>
                      <div className="premiumInfoHolder">
                        <div className="bold-font">
                          {/* <Trans i18nKey="Get">Get</Trans>  */}
                          {this.state.permium_superlikeCount}
                          {this.state.permium_superlikeCount == '1' ?
                            <Trans i18nKey="free super like">free super like</Trans> :
                            <Trans i18nKey="free super likes">free super likes</Trans>
                          }

                        </div>
                        <div className="premiumInfoSubText  secondaryText esmh-14 ">
                          <Trans i18nKey="premiumTextSuper">Giving a Super like is a way to tell someone that you're especially interested in them</Trans>
                        </div>
                      </div>
                    </div> : ''
                  }

                  {this.state.permium_boostCount > 0 ?
                    <div>
                      <div className="premiumImgHolder">
                        <img src={require("../../assets/img/sub_boost.png")} alt="" className="img-fluid" />
                      </div>
                      <div className="premiumInfoHolder">
                        <div className="bold-font">
                          {this.state.permium_boostCount} {this.state.permium_boostCount == 1 ? <Trans i18nKey="free boost">free boost</Trans> : <Trans i18nKey="free boosts">free boosts</Trans>}
                        </div>
                        <div className="premiumInfoSubText  secondaryText esmh-14 ">
                          <Trans i18nKey="premiumTextBoost">Be the top profile in your area for 30minutes to get more matches, Keep Swipe right!</Trans>
                        </div>
                      </div>
                    </div> : ''
                  }

                  <div>
                    <div className="premiumImgHolder">
                      <img src={require("../../assets/img/sub_location.png")} alt="" className="img-fluid" />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Change Location">Change Location</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextLocation">Get match and chat with others around the world by simply searching for a city</Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img src={require("../../assets/img/sub_morelike.png")} alt="" className="img-fluid" />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Unlimited Likes">Unlimited Likes</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextUnlimited">Feel special again with 'Unlimited Likes'. Swipe right as much as you want!</Trans>
                      </div>
                    </div>
                  </div>


                  <div>
                    <div className="premiumImgHolder">
                      <img src={require("../../assets/img/sud_add.png")} alt="" className="img-fluid" />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Rewind">Rewind</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextRewind">Accidentally swiped on someone? Rewind lets you take back your last Like or Nope</Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img src={require("../../assets/img/sub_morelike2.png")} alt="" className="img-fluid" />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Unlimited Liked">Find out who likes you</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextUnlimiteds">This feature allows you to see who has liked you!</Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img src={require("../../assets/img/sub_profile.png")} alt="" className="img-fluid" />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Control your profile">Control your profile</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextProfile">Limit what others see and make parts of your profile information invisible to other people</Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img src={require("../../assets/img/sub_visited.png")} alt="" className="img-fluid" />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Visitors ">See who visited your profile</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextVisited">A Visitors feature lets you see who looked at your profile or ‘visited’ your profile
                        </Trans>
                      </div>
                    </div>
                  </div>



                  <div>
                    <div className="premiumImgHolder">
                      <img src={require("../../assets/img/sud_add2.png")} alt="" className="img-fluid" />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Turn Off Ads">Turn Off Ads</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextAds">Have fun swiping with uninterrupted ads</Trans>
                      </div>
                    </div>
                  </div>

                </Swiper>
              </div>
              {
               /* this.state.timer_status == 1  ? 
                
                <Countdown 
                            startdate = {this.state.start_date}                            
                            enddate = {this.state.end_date}
                            >
                                                        </Countdown>

                                                        : ''*/}

              <div className="premiumPopPlans">
                <Swiper {...params2}>
                  {this.state.items.map((item, index) =>
                    <div className={this.state.activeItem === item.id ? 'navigation--active' : ''} onClick={this.handleItemClick.bind(this, item.id)} alt={item.id} value={item.id}>
                      <div className="premiumPrice">

                        <div className="apd10 daysPrice">
                          <div className="bold-font apk-30">{item.days}</div>
                          <div className=" bold-font apk-24 mt-n2"><Trans i18nKey={item.type}>{item.type}</Trans></div>
                        </div>
                        <div className="apd5 apk-16 mini-price">{this.state.currency}{item.price}</div>
                      </div>
                    </div>)}

                </Swiper>
              </div>
              <ul class="ubp-ul text-center justify-content-end amt20">
                <li class="in-flex"><button class="btn-block amgAuto border-0 bg-white" onClick={this.toggle}><Trans i18nKey="Cancel">Cancel</Trans></button></li>
                <li class="in-flex"><NavLink to={{
                  pathname: '/app/WalletPayment',
                  paytype: { type: 'premium', item_id: this.state.activeItem && this.state.activeItem }
                }}> <button class="btn-block amgAuto border-0 bg-white pink-color" onClick={this.toggleclose}><Trans i18nKey="Continue">Continue</Trans> </button></NavLink></li>
              </ul>

              {/* <div className='row'>
                <div className='col-md-6'>
                  <div className="sidebarLastContent text-center">
                        <NavLink to={{
                          pathname:'/app/WalletPayment',
                          paytype: {type:'premium'} 
                        }}> 
                        <button className="btn-common btn-block" onClick={this.toggleclose}><Trans i18nKey="Continue">Continue</Trans></button>
                        </NavLink>   
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className="sidebarLastContent text-center">
                        <NavLink to={{
                          pathname:'/app/WalletPayment',
                          paytype: {type:'premium'} 
                        }}> 
                        <button className="btn-common btn-block" onClick={this.toggleclose}><Trans i18nKey="Continue">Continue</Trans></button>
                        </NavLink>   
                  </div>
                </div>
              </div> */}



            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={this.state.modal22} toggle={this.homeLink} className="premiumPopup vertically-center apd5">
          <ModalHeader toggle={this.homeLink}><h4 class="modal-title" style={{ 'marginTop': "10px" }}><Trans i18nKey={this.state.message}>{this.state.message}</Trans></h4></ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <div class="d-flex justify-content-end">
                <div class="mr-3"><button class="border-0 bg-white pink-color" onClick={this.homeLink}><Trans i18nKey="Ok">Ok</Trans></button></div>
              </div>
            </div>
          </ModalBody>
        </Modal>








      </div>

    );
  }
}


export default withTranslation("translations")(withRouter(SideBar)); 
